import React from 'react';
import {HtmlParse} from 'utils';
import Link from 'components/Link';
import PropTypes from 'prop-types';
import style from './style.scss';//NOSONAR

const BannerInfo = (props) => {
    const {content} = props;
    if(!content) return '';

    return <section className='home-banner-info'>
        <Link to={content.url} target='_blank' className='home-banner-info-container'>
            <h3 className='home-banner-info-title'>{content.title}</h3>
            <div className='home-banner-info-text'>{HtmlParse(content.text)}</div>
            {content.url && content.urlText && <button className='primary-btn'>{content.urlText}</button>}
        </Link>
    </section>;
}

BannerInfo.propTypes = {
    content: PropTypes.object
};

export default BannerInfo;
